import FqApi from '@/services/fq-api'

const baseUrl = '/systemmodule'

export default {
  async getAllPermissionRecords() {
    let url = `${baseUrl}/getAllPermissionRecords`
    const result = await FqApi.get(url)
    return result.data
  },
  async updatePermissionRecords(permissionRecords) {
    let url = `${baseUrl}/updatePermissionRecords`
    const result = await FqApi.put(url, permissionRecords)
    return result.data
  }
}
